import React from 'react';
import Logo from '../../common/logo';

import './Home.css';

function Home() {
  return (
    <div className="home">

      <a href={window.location.origin}><Logo /></a>

      <p className="home__description">
        We forecast how unfinished business ends &mdash;<br />
        what comes back, what it caused and what you owe &mdash;<br />
        as your measurement team or alongside the one you have.
      </p>
    </div>
  );
}

export default Home;
